import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Creator from "@/pages/Creator";
import Templates from "@/pages/Templates";
import MyCreations from "@/pages/MyCreations";
import Studio from "@/pages/Studio";
import Pricing from "@/pages/Pricing";
import Playlists from "@/pages/Playlists";
import Discover from "@/pages/Discover";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import SubscriptionCancel from "@/pages/SubscriptionCancel";
import Navigation from "@/components/Navigation";
import CosmicBackdrop from "@/components/CosmicBackdrop";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen text-foreground relative overflow-x-hidden">
        {/* GLOBAL PARALLAX COSMIC BACKDROP — 3-layer depth with mouse tilt + scroll drift */}
        <CosmicBackdrop />

        <BrowserRouter>
          <Navigation />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/create" element={<Creator />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/my-creations" element={<MyCreations />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/playlists" element={<Playlists />} />
              <Route path="/discover" element={<Discover />} />
              <Route path="/subscription/success" element={<SubscriptionSuccess />} />
              <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
            </Routes>
          </main>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </AuthProvider>
  );
}

export default App;
